import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { OrderState } from 'src/app/module/order/state/order.state';
import {
  API_ACTION,
  API_SCOPE,
  API_WRITE_ACTION_TYPE,
  ApiAction,
  ApiScope,
  ApiWriteActionType,
} from './interceptor.token';

export const READ_ONLY_BLOCKED_TYPE = 'READ_ONLY_BLOCKED';

const READ_ONLY_BLOCKED_MESSAGE = 'This action is not allowed while the order is open in Read-Only mode.';

/**
 * A blocked request is expected behaviour rather than a failure, so callers that fire
 * automatically (auto-save) can recognise it and stay silent.
 */
export function isReadOnlyBlockedError(error: unknown): boolean {
  return error instanceof HttpErrorResponse && error.error?.type === READ_ONLY_BLOCKED_TYPE;
}

/**
 * Interceptor to block write operations in read-only mode.
 */
export const readOnlyInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const orderState = inject(OrderState);

  const apiAction = req.context.get(API_ACTION);
  const apiScope = req.context.get(API_SCOPE);
  const apiWriteActionType = req.context.get(API_WRITE_ACTION_TYPE);

  if (
    orderState.readOnlyMode &&
    apiAction === ApiAction.WRITE &&
    apiScope === ApiScope.ORDER &&
    apiWriteActionType === ApiWriteActionType.TRANSITION
  ) {
    console.warn('Action not allowed in Read-Only mode', req);

    /** Errors instead of completing empty so the caller can never hang waiting on a response. */
    return throwError(
      () =>
        new HttpErrorResponse({
          status: 403,
          statusText: 'Forbidden',
          url: req.url,
          error: { type: READ_ONLY_BLOCKED_TYPE, message: READ_ONLY_BLOCKED_MESSAGE },
        })
    );
  }

  return next(req);
};
